import script from "./gamePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./gamePanel.vue?vue&type=script&setup=true&lang=ts"

import "./gamePanel.vue?vue&type=style&index=0&id=4bff52f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bff52f0"]])

export default __exports__